import { SolLayout, SolViewId, SolViewOptions } from '@sol/components';
import { SubscopeNameViewOptions } from '../components/view/asm-view-edit-subscope-name/asm-view-edit-subscope-name.component';
import { SubscopeSeedSelectViewOptions } from '../components/view/asm-view-edit-subscope-seed-select/asm-view-edit-subscope-seed-select.component';

export class AsmScopesViewId {
  public static readonly scopeModule = SolViewId.of<SolViewOptions>('asm.scopeModule', {
    layout: SolLayout.of().withPy('4'),
  });
  public static readonly subscopeNameEdit = SolViewId.of<SubscopeNameViewOptions>('subscopeNameEdit');
  public static readonly subscopeSeedSelectEdit =
    SolViewId.of<SubscopeSeedSelectViewOptions>('asm.subscopeSeedSelectEdit');
}
